import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { drawCategoryTypeIds } from '../../../utils/eventConstants';
import { comparator, ComparatorTypes } from '../../../utils/comparator';
import DrawListItem from './DrawListItem';

import styles from './nextAvailable.scss';

const DrawsContainer = (props) => {
    const {
        statusType,
        className,
        event,
        onDrawSettingsEdit,
    } = props;
    const [selectedDrawIds, setSelectedDrawIds] = useState([]);
    const nextAvailable = useSelector(({ nextAvailable }) => nextAvailable);

    const {
        isLoadingDraws,
    } = nextAvailable?.sidebar || {};

    const { draws } = nextAvailable;
    const displayableDraws = useMemo(() => {
        return draws?.filter((draw) => {
                return draw.drawStatusToCheck.includes(statusType);
            })
            .map((draw) => {
                const isGroupedDraw = draw.categoryTypeId === drawCategoryTypeIds.GROUPED;
                const updatedStartDate = isGroupedDraw ? draw.childDraws[0]?.startDateTimeUtc : draw.startDateTimeUtc;
                return {
                    ...draw,
                    startDateTimeUtc: updatedStartDate,
                };
            })
            .sort(comparator([{ type: ComparatorTypes.FORMATTED_DATE, field: 'startDateTimeUtc', descend: false }]));
    }, [draws, statusType]);

    const onDrawClick = useCallback((draw) => {
        const isDrawSelected = selectedDrawIds?.includes(draw.customDrawId);
        if (isDrawSelected) {
            const updatedDrawIds = selectedDrawIds.filter((id) => id !== draw.customDrawId);
            setSelectedDrawIds(updatedDrawIds);
        } else {
            setSelectedDrawIds([
                ...selectedDrawIds,
                draw.customDrawId,
            ]);
        }
    }, [selectedDrawIds]);

    return (
        <>
            {isLoadingDraws && (
                <div className={styles.spinner} data-testid="next-available.draws.loading">
                    <div className={styles.iconWrapper}>
                        <i className="icon-utr-logo" />
                        <div className={styles.iconSpinner} />
                        <div className={`${styles.iconSpinner} ${styles.reverse}`} />
                    </div>
                    <div className={styles.title}>Loading</div>
                </div>
            )}
            {!isLoadingDraws && (
                <div
                    className={`${styles.drawsContainer} ${className}`}
                    data-testid="next-available.draws.list"
                >
                    {displayableDraws?.length > 0 && displayableDraws.map((draw) => {
                        return (
                            <DrawListItem
                                key={draw.customDrawId}
                                className={`${styles.contentSection}`}
                                draw={draw}
                                event={event}
                                onDrawSettingsEdit={onDrawSettingsEdit}
                                statusType={statusType}
                                onDrawClick={onDrawClick}
                                selectedDrawIds={selectedDrawIds}
                                data-testid={`next-available.draw-${draw.id}`}
                            />
                        );
                    })}
                </div>
            )}
        </>
    );
};

DrawsContainer.propTypes = {
    className: PropTypes.string,
    statusType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    event: PropTypes.objectOf(PropTypes.any).isRequired,
    onDrawSettingsEdit: PropTypes.func.isRequired,
};

DrawsContainer.defaultProps = {
    className: '',
};

export default DrawsContainer;
